import { ChangeDetectionStrategy, Component } from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import { FooterComponent } from './shared/footer/footer.component';
import {HeaderComponent} from './pages/dashboard/header/header.component';
import {CommonModule, NgIf} from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [FooterComponent, RouterOutlet, HeaderComponent, CommonModule, NgIf],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'Arcade Platform';

  constructor(private router: Router) {}

  shouldShowHeader(): boolean {
    const hiddenRoutes = ['/auth', '/profile-setup', '/terms-of-service', '/privacy-policy'];
    return !hiddenRoutes.includes(this.router.url);
  }
}
